import { render, staticRenderFns } from "./uyeDetay.vue?vue&type=template&id=15850965&scoped=true&"
import script from "./uyeDetay.vue?vue&type=script&lang=js&"
export * from "./uyeDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15850965",
  null
  
)

export default component.exports